VjsAdmin.AdminOneRosterQueue = SafeDOM.makeAdminQueueModule({ // eslint-disable-line no-undef
    tableSelector: '#oneroster-table',
    formatNoMatchesMsg: 'No oneroster records AT ALL!!!',
    urlRoute: 'admin.oneroster.queue.json',
    idField: 'queue_id',
    queuedDateField: 'date_queued',
    responseHandlerCfg: {
        rowIdField: 'queue_id',
        moveToFrontIdParam: 'queue_id',
        hasClassesRow: true,
        cancelPermission: 'platforms.districts.oneroster.queue.cancel',
        cancelRoute: 'platforms.districts.oneroster.queue.cancel',
        moveToFrontPermission: 'admin.oneroster.queue.moveToFront',
        moveToFrontRoute: 'admin.oneroster.queue.moveToFront',
        viewPermission: 'platforms.districts.oneroster.queue.view',
        viewRoute: 'platforms.districts.oneroster.queue.view',
    },
});
